import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails, UserUpdateRequestDTO } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class UpdateUserStatusCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IUpdateUserStatusCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'users/{userId}';
  override _needAuthenticate = true;

  public override setParameters(parameters: IUpdateUserStatusCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{userId}',
      parameters.userId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IUpdateUserStatusCommandParameters
  extends UserUpdateRequestDTO,
    ICommandParameters {
  userId?: number;
}

export interface IUpdateUserStatusResponse extends ICommandResponse {}
